import React, {useEffect} from "react";
import {useParams, useNavigate} from "react-router-dom";
import axios from "axios";
import useCategory from "./useCategory";
import Card from "../../Components/Cards/Card";
import SubmitButton from "../../Components/Buttons/SubmitButton";
import InfoCard from "../../Components/Cards/InfoCard";
import swal from 'sweetalert';

export default function () {
  const {reset, handleSubmit, setErrors, setData, editCategoryFields} = useCategory();
  const {id} = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    axios.get('categories/' + id).then(res => {
      const category = res.data.category;

      setData({...res.data.data, is_last: category.is_last});
      reset(category);
    });
  }, []);

  const editCategory = data => {
    const formData = new FormData();

    Object.entries(data).forEach(([property, value]) => {
      if (!['products', 'codes'].includes(property)) {
        formData.append(`${property}`, value || '');
      }
    });

    data?.products && data?.products.forEach(item => formData.append('products[]', item));

    data?.codes?.forEach((item, index) => {
      Object.entries(item).forEach(([property, value]) => {
        formData.append(`codes[${index}][${property}]`, value || '');
      });
    });

    formData.append("_method", "PATCH");

    axios.post('categories/' + data.id, formData)
      .then(function (res) {
        if (res.status == 200) {
          swal('Category has been updated successfully!', {
            icon: "success",
          });
          navigate(-1);
        }
      })
      .catch(function (error) {
        if (error.response) {
          setErrors(error.response.data.errors || {});
        }
      });
  }

  return (
    <Card title="Edit category" classes="category edit">
      <form className="form w-100 row" onSubmit={handleSubmit(editCategory)}>
        <InfoCard/>
        {editCategoryFields}
        <div className="col-12 mt-10">
          <SubmitButton
            title="Update"
            classes="w-auto d-inline-block"
          />
        </div>
      </form>
    </Card>
  );
}